export const regularData = [
  {
    id: "overview",
    title: "Overview",
    navLink: "/menu/regular/overview",
  },

  {
    id: "setMenu",
    title: "Set Menu",
    navLink: "/menu/regular/setMenu",
  },

  {
    id: "categories",
    title: "Categories",
    navLink: "/menu/regular/categories",
  },

  {
    id: "items",
    title: "Items",
    navLink: "/menu/regular/items",
  },
]